import { ref } from 'vue'

// 控制客服侧边栏高亮状态，点击"了解详情"时触发
export const sidebarHighlight = ref(false)

export function triggerSidebarHighlight() {
  sidebarHighlight.value = true
  setTimeout(() => {
    sidebarHighlight.value = false
  }, 2000)
}
